import ReportUtils from "../../../../../utils/report-utils.js";

const IndividualProfileContent = ({ data }) => {

    if (!data.individualsProfile?.length) {
        return (
            <div className="chart-report">
                <span className="chart-title">
                    Perfil mais presente por condição
                </span>

                <div className="alert alert-info p-2 h6 text-center mt-3">
                    Nenhum registro encontrado no período informado.
                </div>
            </div>
        );
    }

    return (
        <div className="chart-report">
            <span className="chart-title">Perfil mais presente por condição {data.individualsProfile?.length >= 5 ? " (TOP 5)" : ""}
            </span>

            <div className="mt-3 mb-3">
                <table id="average-profile-condition-data" className="table report-table">
                    <thead className="thead-background">
                        <tr className="bg-[#f6f6f6] text-left">
                            <th className="w-[10%]">Condição</th>
                            <th className="w-[10%]">Quantidade</th>
                            <th className="w-[10%]">Sexo</th>
                            <th className="w-[10%]">Estado civil</th>
                            <th className="w-[10%]">Idade</th>
                            <th className="w-[15%]">Nacionalidade</th>
                            <th className="w-[15%]">Naturalidade</th>
                        </tr>
                    </thead>

                    <tbody className="bg-white">
                    {data.individualsProfile?.map((element, index) => (
                        <tr key={index}>
                            <td>{ReportUtils.formatText(element.classif)}</td>
                            <td>{element.qty}</td>
                            <td>{ReportUtils.formatText(element.sex)}</td>
                            <td>{ReportUtils.formatText(element.marital_status)}</td>
                            <td>{element.age_range}</td>
                            <td>{ReportUtils.formatText(element.nationality)}</td>
                            <td>{element.naturality}</td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>

            <span className="obs-warn">
                {data.individualsProfile?.length > 0 ? "* Informação baseada nas ocorrências do Sentry View" : ""}
            </span>
        </div>
    );
};

export default IndividualProfileContent;